export const AUTH_TOKEN = 'formclue_auth_token';
export const AUTH_AUTO_BILLING = 'formclue_auto_billing';
export const AUTH_USER = 'formclue_user';
export const TURNSTILE_SITE_KEY = "0x4AAAAAAB6ckQ807Dv9Sdhv";
